var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mainfooter"},[_c('p',[_c('small',[_vm._v(" COPYRIGHT TELLER AGENCY SERVICES LIMITED 2020 ")])])])}]

export { render, staticRenderFns }